module.exports = __webpack_public_path__ + "static/schmidt-futures-25f15f66f3f3b0c1f007a2247207ed44.png";